import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

// Iter39 UX polish: consistent "← Back to Admin" breadcrumb on every admin
// sub-page (Campaigns, Events, FAQs, Roadmap, Tickets). Sits *above* the
// section-eyebrow so it reads as a proper breadcrumb, not a mixed-in link.
// Deliberately small + low-contrast so it never competes with the H1.
export default function BackToAdminLink() {
  return (
    <Link
      to="/admin"
      className="inline-flex items-center gap-1 text-xs text-black/55 hover:text-black mb-3 font-semibold uppercase tracking-widest"
      data-testid="back-to-admin-link"
    >
      <ArrowLeft size={12} weight="bold" /> Back to Admin
    </Link>
  );
}
